module.exports = __webpack_public_path__ + "img/credisolvelogo.f7fe9e2f.png";